import { render, staticRenderFns } from "./MainList.vue?vue&type=template&id=df29d6a6&"
import script from "./MainList.vue?vue&type=script&lang=js&"
export * from "./MainList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports